import styled from 'styled-components'
import { H3 } from 'components/typography/heading'

export const Header = styled.div`
    display: flex;
    align-items: center;
    column-gap: 8px;

    margin-bottom: 24px;
`

export const Heading = styled(H3)`
    flex: 0 0 auto;

    margin-bottom: 0;
`